import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import PermissionContext from "../../context/PermissionContext";
import DrawerContext from "../../context/DrawerContext";
import AutoLogout from "../../utils/useAutoLogout";

import Grid from "@mui/material/Grid";

import SideDrawer from "../../components/layout/SideDrawer";
import PageHeader from "../../components/layout/PageHeader";
import MaterialItemCard from "../../components/materialscapture/MaterialCard";

const MaterialCaptureHomePage = () => {
  const navigate = useNavigate();
  
  const { permisionsList, checkUserPermission } = useContext(PermissionContext);
  const { drawerValue, setDrawerValue } = useContext(DrawerContext);  

  useEffect(() => {
    if(permisionsList.length > 0) checkUserPermission([
      'Materials Capture-Lipid Raw Materials', 'Materials Capture-Buffers', 
      'Materials Capture-Payload Raw Materials', 'Materials Capture-Lipid Stocks', 
      'Materials Capture-Payload Phase', 'Materials Capture-Encapsulation Details', 
      'Materials Capture-Mixing',
    ]);
  }, [permisionsList]);

  const lipidData = {
    name: 'Lipid Raw Materials',
    url: '/lipid-raw-materials',
    imgPath: '/rawmaterials.png',
    permissions: ['Materials Capture-Lipid Raw Materials']
  };

  const bufferData = {
    name: 'Buffers',
    url: '/buffers',
    imgPath: '/buffers.png',
    permissions: ['Materials Capture-Buffers']
  };

  const payloadRawMaterialsData = {
    name: 'Payload Raw Materials',
    url: '/payload-raw-materials',
    imgPath: '/payloadrawmaterials.png',
    permissions: ['Materials Capture-Payload Raw Materials']
  };

  const lipidStocksData = {
    name: 'Lipid Stocks',
    url: '/lipid-stocks',
    imgPath: '/lipidstocks.png',
    permissions: ['Materials Capture-Lipid Stocks']
  };

  const payloadPhasesData = {
    name: 'Payload Phase',
    url: '/payload-phase',
    imgPath: '/payloadphase.png',
    permissions: ['Materials Capture-Payload Phase']
  };

  const encapsulantPhasesData = {
    name: 'Encapsulation Details',
    url: '/encapsulation-details',
    imgPath: '/encapsulantphase.png',
    permissions: ['Materials Capture-Encapsulation Details']
  };

  const mixingData = {
    name: 'Mixing',
    url: '/mixing',
    imgPath: '/mixing.png',
    permissions: ['Materials Capture-Mixing']
  };

  const dilutionData = {
    name: 'Dilution',
    url: '/dilution',
    imgPath: '/dilution.png',
    permissions: ['Materials Capture-Dilution']
  };

  const finalLNPSampleData = {
    name: 'Final LNP Sample',
    url: '/final-lnp-sample',
    imgPath: '/finallnpsample.png',
    permissions: ['Materials Capture-Final LNP Sample']
  };

  const materialsCaptureList = [
    lipidData, bufferData, payloadRawMaterialsData, lipidStocksData, 
    payloadPhasesData, encapsulantPhasesData, mixingData, dilutionData,
    finalLNPSampleData,
  ];

  const handleClick = (url) => {
    navigate(url);
  };

  return(
    <AutoLogout>
      <SideDrawer drawerValue={drawerValue} setDrawerValue={setDrawerValue} />
      <div className="mainContainer" style={{ marginLeft: drawerValue.drawerWidth }}>
        <PageHeader title={'Materials Capture'} />

        <Grid container spacing={1} sx={{ marginTop: 2 }}>
          {materialsCaptureList.map((data, index) => (
            data.permissions.some(r => permisionsList.includes(r)) &&
            <Grid item xs={12} sm={12} md={4} key={index}>
              <MaterialItemCard data={data} handleClick={handleClick} />
            </Grid>
          ))}
        </Grid>
      </div>
    </AutoLogout>
  );
};

export default MaterialCaptureHomePage;